import { render, staticRenderFns } from "./FilterSaveModal.vue?vue&type=template&id=5228cb61&scoped=true"
import script from "./FilterSaveModal.vue?vue&type=script&lang=js"
export * from "./FilterSaveModal.vue?vue&type=script&lang=js"
import style0 from "./FilterSaveModal.vue?vue&type=style&index=0&id=5228cb61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228cb61",
  null
  
)

export default component.exports